import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const bodyContainer = document.querySelector('body');
  const alertsBar = document.querySelector('.alerts-bar__inner');

  if (alertsBar) {
    bodyContainer.classList.add('alerts-bar-active');
    new Swiper(alertsBar, {
      slidesPerView: 1,
      pagination: {
        el: '.alert-controls',
        clickable: true,
      },
    });
  }

  const closeAlert = document.querySelector('.alerts-bar__close-button');

  if (closeAlert) {
    closeAlert.addEventListener('click', function () {
      closeAlertBar();
    });
  }

  function heightAlertBar() {
    const alertsBarWrapper = document.getElementById('alerts-bar');

    if (!alertsBarWrapper) {
      return;
    }

    const alertHeight = alertsBarWrapper.offsetHeight;
    alertsBarWrapper.style.setProperty('--AlertHeight', alertHeight + 'px');
    document.documentElement.style.setProperty(
      '--AlertHeight',
      alertHeight + 'px'
    );
  }

  function closeAlertBar() {
    document.querySelector('.alerts-bar-swiper').remove();
    bodyContainer.classList.remove('alerts-bar-active');
  }

  heightAlertBar();

  window.addEventListener('resize', function () {
    heightAlertBar();
  });
});
